import { alpha, styled } from "@mui/material/styles";
import { bgGradient } from "../../utils/minimal/cssStyles";

// Used on Home Page, and Ticket Page
export const StyledRoot = styled('div')(({ theme, fixed = true }) => ({
    // position: 'relative',
    ...bgGradient({
        color: alpha(theme.palette.background.default, theme.palette.mode === 'light' ? 0.8 : 0.9),
        imgUrl: theme.direction === 'rtl' ? '/assets/background/overlay_2_rotate.jpg' : '/assets/background/overlay_2.jpg',
    }),
    // when change back to original layout:
    // [theme.breakpoints.up('md')]: {
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh',
    position: fixed ? 'fixed' : 'relative',
    overflow: 'hidden',
    // },
}));
